import React from 'react'
import "./Caract__style.scss"

export default function Useless({item, hatImage, cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage}) {

    const images = {
        pa: require("./../../../Asset/Stuff/pa.png"),
        pm: require("./../../../Asset/Stuff/pm.90f0ffe6.png"),
        fui: require("./../../../Asset/Stuff/fuite.png"),
        pod: require("./../../../Asset/Stuff/pod.png"),
        tac: require("./../../../Asset/Stuff/tac.png"),
        esqpm: require("./../../../Asset/Stuff/esqpm.png"),
    }

    const getTotalCaractValue = (items, type) => {
        return items.reduce((total, item) => {
            if (item && Array.isArray(item.effects)) {
            const effect = item.effects.find((effect) => effect.type.name === type);
            if (effect) {
                return total + (effect.int_maximum || 0);
            }
        }
        return total;
        }, 0);
    };
    

    return (
    <div className="stats__style">
        <div className="stats__wrapper">
            <div className="stats fui">
                <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Fuite') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Fuite')}</div> <span><img src={images.fui} alt="" /></span> Fuite
            </div>
            <div className="stats esqPa">
                <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Esquive PA') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Esquive PA')}</div> <span><img src={images.pa} alt="" /></span> Esq. PA
            </div>
            <div className="stats esqPm">
                <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Esquive PM') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Esquive PM')}</div> <span><img src={images.esqpm} alt="" /></span> Esq. PM
            </div>
            <div className="stats pods">
                <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Pods') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Pods')}</div> <span><img src={images.pod} alt="" /></span> Pods
            </div>
        </div>
        <div className="stats__wrapper">
            <div className="stats tac">
                <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Tacle') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Tacle')}</div> <span><img src={images.tac} alt="" /></span> Tacle
            </div>
            <div className="stats retPA">
                <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Retrait PA') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Retrait PA')}</div> <span><img src={images.pa} alt="" /></span> Ret. PA
            </div>
            <div className="stats retPM">
                <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Retrait PM') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Retrait PM')}</div> <span><img src={images.esqpm} alt="" /></span> Ret. PM
            </div>
        </div>
    </div>
    )
}
